module.exports = __webpack_public_path__ + "img/localization.66e87ff7.svg";